import React from 'react'
import { CCard, CCardBody, CFormSelect, CRow, CSmartTable } from '@coreui/react-pro'
const AllPlayerStatsTab = (props) => {
  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CSmartTable
              color="dark"
              header
              columns={props.columns}
              columnFilter={{
                external: true,
              }}
              columnSorter={{
                external: true,
              }}
              scopedColumns={{
                player_name: (item) => <td>{item?.player_name}</td>,
                position_name: (item) => <td>{item?.position_name}</td>,
                rs: (item) => <td>{item?.sum_rs}</td>,
                sum_fours: (item) => <td>{item?.sum_fours}</td>,
                sum_sixes: (item) => <td>{item?.sum_sixes}</td>,
                sum_overs: (item) => <td>{item?.sum_overs}</td>,
                sum_mdns: (item) => <td>{item?.sum_mdns}</td>,
                sum_cs: (item) => <td>{item?.sum_cs}</td>,
                sum_wks: (item) => <td>{item?.sum_wks}</td>,
                sum_cwks: (item) => <td>{item?.sum_cwks}</td>,
                sum_sts: (item) => <td>{item?.sum_sts}</td>,
                sum_rods: (item) => <td>{item?.sum_rods}</td>,
                sum_roas: (item) => <td>{item?.sum_roas}</td>,
                sum_dks: (item) => <td>{item?.sum_dks}</td>,
              }}
              items={props.users?.data}
              itemsPerPage={props.itemsPerPage}
              itemsPerPageSelect
              loading={props.loading}
              pagination={{
                external: true,
              }}
              paginationProps={{
                activePage: props.activePage,
                pages: Math.ceil(props.users?.total / props.itemsPerPage) || 1,
              }}
              tableProps={{
                hover: true,
                responsive: true,
              }}
              onActivePageChange={(activePage) => props.setActivePage(activePage)}
              onColumnFilterChange={(filter) => {
                props.setActivePage(1)
                props.setColumnFilter(filter)
              }}
              onItemsPerPageChange={(itemsPerPage) => {
                props.setActivePage(1)
                props.setItemsPerPage(itemsPerPage)
              }}
              onSorterChange={(sorter) => props.setColumnSorter(sorter)}
            />
          </CRow>
        </CCardBody>
      </CCard>
    </>
  )
}

export default AllPlayerStatsTab
